// 

/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import {
  updatePassword,
  verifyResetLink,
  getPasswordCreteria
} from "../api/api";
import { withTranslation } from "react-i18next";
import ReactLoading from "react-loading";
import SuccessScreen from "./common/SuccessScreen";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import TextInput from "./common/TextInput";
import getParameter from "../util";
import ErrorAlert from "./common/ErrorAlert";
import SpecificExceptions from "../api/specific-exceptions";

const win = window;
let verifyLink = false;

class ResetPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      transactionId: this.props.transactionId,
      password: "",
      confirmPassword: "",
      errors: { password: "", confirmPassword: "" },
      formIsValid: false,
      isSuccess: false,
      loading: false,
      toolTipMessage: "",
      passRegExpression: "",
      resetPassTips: "",
      genericError: null,
    };
  }

  async componentDidMount() {
    const result = await getPasswordCreteria();
    const result1 = JSON.parse(result);
    const tooltipInfo = result1.data.user_password_rules_info.tool_tip_info;

    let tooltipText = "";
    let criteriaText = "";

    if (window.lang === "en") {
      tooltipInfo.description.forEach(item => {
        tooltipText += item.en ? `${item.en}\n\n` : "";
      });
      tooltipInfo.criteria_info.forEach(item => {
        criteriaText += `${item.en} \n\n`;
      });

      const toolTipMessage_en = tooltipText + criteriaText;
      const resetPasswordTips_en =
        "Password security tips:\n\nTo ensure the highest standards of security, here are some tips to make your password as secure as possible:\n\n-" +
        toolTipMessage_en +
        "- Do NOT share your password with anyone.\n\n- Change your password approximately every 60 days.\n\n- Choose a password that is hard to guess.";

      this.setState({
        toolTipMessage: toolTipMessage_en,
        passRegExpression: result1.data.user_password_rules_info.reg_expression,
        resetPassTips: resetPasswordTips_en,
      });
    } else if (window.lang === "ar") {
      tooltipInfo.description.forEach(item => {
        tooltipText += item.ar ? `${item.ar}\n\n` : "";
      });
      tooltipInfo.criteria_info.forEach(item => {
        criteriaText += `${item.ar} \n\n`;
      });

      const toolTipMessage_ar = tooltipText + criteriaText;
      const resetPasswordTips_ar =
        "نصائح لحماية كلمة المرور:\n\nلضمان أعلى معايير الأمان، إليك بعض النصائح لجعل كلمة مرورك آمنة قدر الإمكان:\n\n-" +
        toolTipMessage_ar +
        "- لا تشارك كلمة مرورك مع أي شخص.\n\n- قم بتغيير كلمة المرور الخاصة بك كل 60 يومًا تقريبًا.\n\n- اختر كلمة مرور يصعب تخمينها.";

      this.setState({
        toolTipMessage: toolTipMessage_ar,
        passRegExpression: result1.data.user_password_rules_info.reg_expression,
        resetPassTips: resetPasswordTips_ar,
      });
    }
  }

  handleValidation(formData) {
    const errors = {};
    let formIsValid = true;

    for (let [key, value] of formData) {
      if (key === "password") {
        const passwordRegex = new RegExp(this.state.passRegExpression, "i");
        if (value && !passwordRegex.test(value)) {
          errors[key] = "password_match_pattern";
          formIsValid = false;
        }
      }

      if (key === "confirmPassword") {
        if (value && value !== this.state.password) {
          errors[key] = "password_not_match";
          formIsValid = false;
        }
      }
    }

    this.setState({ errors });
    return formIsValid;
  }

  handleChange = e => {
    const { name, value } = e.target;
    this.setState({ [name]: value }, () => {
      const errors = { ...this.state.errors };
      if (name === "password") {
        const passwordRegex = new RegExp(this.state.passRegExpression);
        errors.password = value && !passwordRegex.test(value) ? "password_match_pattern" : "";
      }

      if (this.state.confirmPassword && this.state.confirmPassword !== this.state.password) {
        errors.confirmPassword = "password_not_match";
      } else {
        errors.confirmPassword = "";
      }

      this.setState({
        errors,
        formIsValid: !errors.password && !errors.confirmPassword,
      });
    });
  };

  handleConfirmPassword = e => {
    const { name, value } = e.target;
    this.setState({ [name]: value }, () => {
      const errors = { ...this.state.errors };
      errors.confirmPassword = value !== this.state.password ? "password_not_match" : "";
      this.setState({
        errors,
        formIsValid: !this.state.errors.password && !errors.confirmPassword,
      });
    });
  };

  sendUpdatePassword = async () => {
    const requestBody = {
      transactionId: this.state.transactionId.split(" ").join("+"),
      newPassword: this.state.password,
    };
    this.setState({ loading: true });

    try {
      const result = await updatePassword(requestBody);
      this.setState({
        loading: false,
        transactionId: result.transactionId,
        isSuccess: true,
        genericError: null,
      });

      this.props.setMessageDetails({
        headerMsg: "reset_pass_success_msg",
        descriptionMsg: "sign_in_with_new_msg",
        btnLabel: "click_ere_btn",
        returnUrl: "/wps/portal/web/login-page",
      });
      this.props.setShowSuccessMsg(true);
    } catch (error) {
      this.setState({
        genericError: error,
        loading: false,
        isSuccess: false,
      });
    }
  };

  verifyReset = async () => {
    const requestBody = {
      transactionId: this.props.transactionId.split(" ").join("+"),
      verificationCode: this.state.code,
    };
    this.setState({ loading: true });

    try {
      const result = await verifyResetLink(requestBody);
      this.setState({
        isSuccess: true,
        loginUrl: result.loginUrl,
        loading: false,
      });
      verifyLink = true;
    } catch (error) {
      if (error instanceof SpecificExceptions && error.code === "MAPI-024") {
        this.setState({ loading: false });
        verifyLink = false;
      } else {
        this.setState({ genericError: error, loading: false });
        verifyLink = false;
      }
    }
  };

  handleSubmit = async e => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const formIsValid = this.handleValidation(formData.entries());

    if (formIsValid) {
      await this.verifyReset();
      if (verifyLink) {
        await this.sendUpdatePassword();
      }
    }
  };

  render() {
    const { t } = this.props;
    const { errors, toolTipMessage, password, confirmPassword, formIsValid, loading, isSuccess, resetPassTips, genericError } = this.state;

    return (
      <>
        {loading && <div className="loading">Loading&#8230;</div>}
        <div className="loginPage resetPassword">
          {!isSuccess && (
            <section className="login_form">
              <div className="loginIntroTextContainer">
                <h3>{t("reset_password_intro_title")}</h3>
              </div>
              {genericError && <ErrorAlert error={genericError} />}

              <form onSubmit={this.handleSubmit}>
                {/* PASSWORD FIELD */}
                <div className={"form-group " + (errors.password ? "not-valid" : "") + " forgot-password-input"}>
                  <label className="input-label">{t("new_password")}</label>
                  <input
                    type="password"
                    name="password"
                    className="form-control"
                    placeholder={t("new_password")}
                    value={password}
                    maxLength="50"
                    onChange={this.handleChange}
                  />
                  {errors.password && (
                    <div className="alert alert-danger" role="alert">
                      {t(errors.password)}
                      <a
                        data-tooltip-id="passwordTooltip"
                        data-tooltip-content={toolTipMessage}
                        data-event="click focus"
                        style={win.lang === "en" ? { position: 'absolute', right: '0px', top: '-25px' } : { position: 'absolute', left: '0px', top: '-25px' }}
                      >
                        <i
                          aria-hidden="true"
                          className={"fa fa-question-circle password-info" + (win.lang !== "en" ? " fa-flip-horizontal" : "")}
                        ></i>
                      </a>

                      <Tooltip
                        id="passwordTooltip"
                        className={"multi-line-custome-" + win.lang}
                        clickable={true}
                        multiline={true}
                        place="bottom"
                        style={{
                          maxWidth: "399px",
                          backgroundColor: "#00467f",
                          color: "white",
                          right: win.lang === "en" ? "0" : undefined,
                          left: win.lang !== "en" ? "0" : undefined,
                        }}
                      />
                    </div>
                  )}
                </div>

                {/* CONFIRM PASSWORD FIELD */}
                <div className={"form-group " + (errors.confirmPassword ? "not-valid" : "") + " forgot-password-input"}>
                  <label className="input-label">{t("confirm_password")}</label>
                  <input
                    type="password"
                    name="confirmPassword"
                    className="form-control"
                    placeholder={t("confirm_password")}
                    value={confirmPassword}
                    maxLength="50"
                    onChange={this.handleConfirmPassword}
                  />
                  {errors.confirmPassword && (
                    <div className="alert alert-danger" role="alert">
                      {t(errors.confirmPassword)}
                    </div>
                  )}
                </div>

                <button
                  type="submit"
                  className="btn min_outlin_btn active"
                  disabled={!formIsValid}
                  style={{ marginTop: '25px' }}
                >
                  {t("reset_password")} <i className="fa fa-arrow-right" aria-hidden="true"></i>
                </button>
              </form>

              {/* RESET PASSWORD TIPS */}
              <div className="tab-content">{resetPassTips}</div>
            </section>
          )}
        </div>
      </>
    );
  }
}

export default withTranslation()(ResetPassword);
